export { EnviarCorreoModalEdit, Props } from "./modal";


// WEBPACK FOOTER //
// ./app/features/general/operativa/items/facturas/correo/enviarcorreo/index.tsx